import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import PortfolioSplitSection from "@/components/PortfolioSplitSection";
import ContactSection from "@/components/ContactSection";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import SectionDivider from "@/components/SectionDivider";
import SEO from "@/components/SEO";
import { useLanguage } from "@/i18n/LanguageContext";
import { useMemo } from "react";

const SITE_URL = "https://wencek.xyz";

const Index = () => {
  const { t } = useLanguage();
  const isEn = t.contact.footer === "better pictures";
  const lang: "pl" | "en" = isEn ? "en" : "pl";

  const jsonLd = useMemo(() => {
    return [
      {
        "@type": "LocalBusiness",
        "@id": `${SITE_URL}/#localbusiness`,
        name: "Better Pictures — Michał Wencek",
        image: `${SITE_URL}/og-image.jpg`,
        url: SITE_URL,
        telephone: undefined,
        email: "michalwencek@gmail.com",
        priceRange: "$$$",
        address: {
          "@type": "PostalAddress",
          addressLocality: "Warszawa",
          addressRegion: "Mazowieckie",
          addressCountry: "PL",
        },
        geo: { "@type": "GeoCoordinates", latitude: 52.2297, longitude: 21.0122 },
        areaServed: [
          { "@type": "City", name: "Warszawa" },
          { "@type": "Country", name: "Polska" },
          { "@type": "Place", name: "Europa" },
        ],
        openingHoursSpecification: [{
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          opens: "09:00",
          closes: "20:00",
        }],
        sameAs: [
          "https://instagram.com/wencek_michal",
          "https://vimeo.com/betterpictures",
        ],
        hasOfferCatalog: {
          "@type": "OfferCatalog",
          name: "Usługi",
          itemListElement: [
            { "@type": "Offer", itemOffered: { "@type": "Service", name: "Operator drona — zdjęcia i filmowanie z drona Warszawa", serviceType: "Aerial drone photography and video", areaServed: "Warszawa" } },
            { "@type": "Offer", itemOffered: { "@type": "Service", name: "Fotograf eventowy Warszawa", serviceType: "Event photography", areaServed: "Warszawa" } },
            { "@type": "Offer", itemOffered: { "@type": "Service", name: "Fotograf produktowy i reklamowy Warszawa", serviceType: "Commercial & product photography", areaServed: "Warszawa" } },
            { "@type": "Offer", itemOffered: { "@type": "Service", name: "Produkcja wideo i operator kamery Warszawa", serviceType: "Video production", areaServed: "Warszawa" } },
          ],
        },
      },
    ];
  }, [lang]);

  return (
    <main className="min-h-screen bg-background">
      <SEO
        title="Operator drona i fotograf Warszawa — Michał Wencek"
        description="Operator drona, kamery i fotograf z Warszawy. Zdjęcia lotnicze, filmowanie z drona, produkcja wideo, sesje zdjęciowe i fotografia reklamowa dla marek i agencji."
        path="/"
        jsonLd={jsonLd}
      />
      <LanguageSwitcher />
      {/* Sticky hero — strona zsuwa się nad nim (efekt jak webflow.com) */}
      <div className="sticky top-0 h-screen w-full z-0 overflow-hidden">
        <HeroSection />
      </div>

      {/* Content slides up over the hero with a visible rounded top edge */}
      <div className="relative z-10 bg-background rounded-t-[2rem] md:rounded-t-[3rem] -mt-12 md:-mt-16 shadow-[0_-40px_80px_-20px_rgba(0,0,0,0.7)] border-t border-foreground/10">
        <SectionDivider showOsd />
        <PortfolioSplitSection />
      <SectionDivider />
      <AboutSection />
      <SectionDivider />
      <ServicesSection />
      <SectionDivider />
      <ContactSection />
      </div>
    </main>
  );
};

export default Index;
